import { isCommentRichTextEmpty, looksLikeCommentHtml } from './comment-rich-text';

function decodeBasicHtmlEntities(text: string): string {
  return text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&amp;/gi, '&');
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function commentContentToPlainText(content: string): string {
  if (!content) {
    return '';
  }
  if (!looksLikeCommentHtml(content)) {
    return content.trim();
  }
  const withBreaks = content
    .replace(/<\/(p|div|h[1-6]|li|blockquote|tr)>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '');
  return decodeBasicHtmlEntities(withBreaks)
    .split('\n')
    .map((line) => line.replace(/[ \t]+/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function plainTextToBlockquoteHtml(plainText: string): string {
  const normalized = plainText.replace(/\r\n/g, '\n').trim();
  if (!normalized) {
    return '<p></p>';
  }
  const paragraphs = normalized
    .split('\n')
    .map((line) => `<p>${escapeHtml(line)}</p>`)
    .join('');
  return `<blockquote>${paragraphs}</blockquote><p></p>`;
}

export function prependQuoteToReplyHtml(existingHtml: string, plainText: string): string {
  const quoteHtml = plainTextToBlockquoteHtml(plainText);
  if (quoteHtml === '<p></p>') {
    return existingHtml || '<p></p>';
  }
  if (isCommentRichTextEmpty(existingHtml)) {
    return quoteHtml;
  }
  return `${quoteHtml}${existingHtml}`;
}
